"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _InputConstants = require("./InputConstants");

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _FieldsetContext = require("../context/FieldsetContext");

var UITextArea = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UITextArea, _PureComponent);

  function UITextArea() {
    (0, _classCallCheck2.default)(this, UITextArea);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITextArea).apply(this, arguments));
  }

  (0, _createClass2.default)(UITextArea, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          error = _this$props.error,
          inputRef = _this$props.inputRef,
          resize = _this$props.resize,
          styled = _this$props.styled,
          use = _this$props.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "error", "inputRef", "resize", "styled", "use"]);
      var fieldSize = this.context.size;
      var computedClassName = (0, _classnames.default)("form-control private-form__control private-text-area", className, _InputConstants.INPUT_SIZE_OPTIONS[fieldSize], _InputConstants.USE_CLASSES[use], !styled && 'private-form__control--unstyled', error && 'private-form__control--error', resize === false && 'private-text-area--no-resize', {
        'vertical': 'private-text-area--vertical-resize',
        'horizontal': 'private-text-area--horizontal-resize'
      }[resize]);

      var renderedTextArea = _react.default.createElement("textarea", Object.assign({}, rest, {
        className: computedClassName,
        ref: inputRef
      }));

      return renderedTextArea;
    }
  }]);
  return UITextArea;
}(_react.PureComponent);

UITextArea.contextType = _FieldsetContext.FieldsetContext;
UITextArea.displayName = 'UITextArea';
UITextArea.propTypes = {
  cols: _propTypes.default.number,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.bool,
  inputRef: _refObject.default,
  placeholder: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  resize: _propTypes.default.oneOf(['vertical', 'horizontal', true, false]),
  rows: _propTypes.default.number,
  styled: _propTypes.default.bool.isRequired,
  use: _propTypes.default.oneOf(Object.keys(_InputConstants.USE_CLASSES)),
  value: _propTypes.default.string
};
UITextArea.defaultProps = {
  error: false,
  resize: 'vertical',
  styled: true,
  value: ''
};

var _default = (0, _ShareInput.default)((0, _Controllable.default)(UITextArea));

exports.default = _default;
module.exports = exports.default;